import { SisetuResult } from 'interface/sisetu'
import { useState, useCallback } from 'react'

export const useSisetuPreviewDialog = () => {
	const [sisetuList, setSisetuList] = useState<SisetuResult[]>([])
	const [sisetuCode, setSisetuCode] = useState<string | null>(null)

	const openSisetu = useCallback(
		(sisetuCode: string | null) => {
			setSisetuCode(sisetuCode)
		},
		[setSisetuCode]
	)
	const close = useCallback(
		() => openSisetu(null),
		[openSisetu]
	)
	return {
		sisetuList,
		sisetuCode,
		setSisetuList,
		openSisetu,
		close
	}
}